var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertLargeFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 125,
    fill: "none",
    viewBox: "0 0 109 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED3431",
    d: "M54.109 0l54.108 31.24v62.479l-54.108 31.24L0 93.719v-62.48L54.109 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C81A17",
    d: "M54.109 0V124.959L0 93.719v-62.48L54.109 0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 63.734,
    x: 34.657,
    y: 87.724,
    fill: "#fff",
    rx: 4,
    transform: "rotate(-135 34.657 87.724)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 63.734,
    x: 29,
    y: 42.657,
    fill: "#fff",
    rx: 4,
    transform: "rotate(-45 29 42.657)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLargeFail);
export default __webpack_public_path__ + "static/media/AlertLargeFail.05b75f3eac090927e4da67df8144e413.svg";
export { ForwardRef as ReactComponent };